import graphql__71c6d34eefdfeef179d1 from "./__generated__/ParticipativeModuleResultsFormFieldChoicesChart_result.graphql.js";import { graphql, useFragment } from "react-relay";

import Chart from "./Chart";
import { useChartOptions } from "../../lib/charts/useChartColors";

const ParticipativeModuleResultsFormFieldChoicesChart = props => {
  const result = useFragment(
    ParticipativeModuleResultsFormFieldChoicesChart_result,
    props.result
  );

  const {
    allowDisplayingPatternFill,
    chartLabel,
    chartHint,
    results,
    showValues,
    sortByValue
  } = result;

  const { config: chartConfigType, colors } = props;

  const chartOptions = useChartOptions(colors);

  const data = results.reduce((acc, item) => {
    acc[item.label] = item.value;
    return acc;
  }, {});

  const chartConfig = {
    ...chartConfigType(data, {
      label: chartLabel,
      showValues,
      sortByValue
    }),
    ...chartOptions
  };

  return (
    <>
      <Chart
        allowDisplayingPatternFill={allowDisplayingPatternFill}
        chartOptions={chartConfig}
      />

      {/* Only a chart leaving options out is given a hint to display, written by the
          server so this page and the admin's own chart say the same thing */}
      {chartHint && (
        <div className="participative-module-results-form-field-chart-hint text-small text-muted">
          {chartHint}
        </div>
      )}
    </>
  );
};

const ParticipativeModuleResultsFormFieldChoicesChart_result = graphql__71c6d34eefdfeef179d1;

export default ParticipativeModuleResultsFormFieldChoicesChart;
